import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { type FC } from "react";

import * as Styled from "./ResolveDate.styles";
import { useResolveDate } from "./useResolveDate";

export const ResolveDate: FC = () => {
  const { resolveLabel } = useResolveDate();

  if (!resolveLabel) {
    return null;
  }

  return (
    <Styled.Root>
      <AccessTimeIcon />
      <Styled.Label>{resolveLabel}</Styled.Label>
    </Styled.Root>
  );
};
